import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import ReactGA from '~/lib/analytics'
import { useUser } from '~/lib/auth'

export function GARoute() {
  const location = useLocation()
  const user = useUser()

  useEffect(() => {
    if (user.data) {
      ReactGA.set({ userId: user.data.anonymous_uuid, company_id: user.data.company_id, user_email: user.data.email })
    }
  }, [user.data])

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname })
  }, [location])

  return <Outlet />
}
